export const EXAM_STATUS_POLLING_FLAG_KEY = 'academyExamStatusPollingActive';

export const startExamStatusPolling = () => {
  localStorage.setItem(EXAM_STATUS_POLLING_FLAG_KEY, 'true');
};

export const stopExamStatusPolling = () => {
  localStorage.removeItem(EXAM_STATUS_POLLING_FLAG_KEY);
};

export const isExamStatusPollingActive = () => (
  localStorage.getItem(EXAM_STATUS_POLLING_FLAG_KEY) === 'true'
);
